import React from "react";
import axios from "axios";
import { baseURL } from "../Config/Config";
import { NavLink } from "react-router-dom";
import Nima from "./nima";
function ThemeContent({ current_theme }) {
  const [theme, setTheme] = React.useState();
  const [current_content, setCurrent_content] = React.useState(1);
  React.useEffect(() => {
    axios
      .get(`${baseURL}rtr_base_app/theme-detail/${current_theme}/`)
      .then((response) => {
        setTheme(response.data);
        setCurrent_content(1);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [current_theme]);
  if (!theme) return null;
  if (current_theme != 0) {
    return (
      <div className="text-right">
        <div className="materiallar">
          <div className="material-btn">
            {theme.content ? <NavLink onClick={(e) => setCurrent_content(1)}> Maruza matn</NavLink> : null}
          </div>
          <div className="material-btn">
            {theme.media ? <NavLink onClick={(e) => setCurrent_content(2)}>Media materiallar</NavLink> : null}
          </div>
          <div className="material-btn">
            {theme.show_material.length != 0 ? <NavLink onClick={(e) => setCurrent_content(3)}>Ko‘rgazma materiallari</NavLink> : null}
          </div>
          <div className="material-btn">
            {theme.presentation ? <a target='_blank' className="active" href={theme.presentation}> Taqdimotlar</a> : null}
          </div>
          <div className="material-btn">
            {theme.practical_assignment ? <NavLink onClick={(e) => setCurrent_content(4)}>Nazariy-amaliy topshiriqlar</NavLink> : null}
          </div>
          <div className="material-btn">
            {theme.methodological_recommendation ? <a target='_blank' className="active" href={theme.methodological_recommendation}> Metodik tavsiyalar</a> : null}
          </div>
          <div className="material-btn">
            {theme.educational_technologies ? <a target='_blank' className="active" href={theme.educational_technologies}> Ta'lim texnalogiyalari</a> : null}
          </div>
        </div>
        <div className="subject">
          <div className="subject-name">{theme.title}</div>
          <div className="audio"></div>
        </div>
        <div>
          <Nima theme={theme} current_content={current_content} />
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default ThemeContent;
